import { Box, Heading, Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Card from "shared/components/horizon-ui/card/Card";
import InfiniteTable from "shared/components/table/InfiniteTable";
import useGetColors from "shared/hooks/useGetColors";
import { ModuleE, PathsE, PathsParams } from "shared/routes";
import { useGetColumns, useGetGetBreadcrumbs } from "./constants";
import { useParams } from "react-router-dom";
import {
  useGetOneService,
  useGet3thPartyServices,
} from "shared/api/requests/services";
import PageTitle from "shared/views/admin/PageTitle";
import { GroupsT } from "shared/api/types/services";
import { TableNameE } from "shared/api/types/common";
import DialogMessages from "../dialog_messages/Index";
import NewsTable from "../news/Index";

const Index = () => {
  const { t } = useTranslation();
  const { serviceId } = useParams<PathsParams[PathsE.GROUPS]>();
  const { blue800 } = useGetColors();

  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined,
  });

  const { useGetServiceModule } =
    useGet3thPartyServices({
      domain: currentService?.domain,
      token: currentService?.token,
      module: ModuleE.GROUPS,
    });


  const columns = useGetColumns();
  const breadcrumbs = useGetGetBreadcrumbs();

  if (!currentService) return null;

  return (
    <Flex direction="column" w="100%" h="100%" gap="20px" overflow="hidden">
      <Box maxH={"30%"} w="100%">
        <PageTitle title={t("services.dialogs")} breadcrumbs={breadcrumbs} />
        <Card borderRadius="20px" p="30px" shadow="md">
          <Flex alignItems="center">
            <Heading size="md" color={blue800}>
              {t("services.groupsTable")}
            </Heading>
          </Flex>
          <InfiniteTable<GroupsT>
            query={useGetServiceModule as FixMeLater}
            columns={columns}
            tableName={TableNameE.GROUPS}
            hidePagination
          />
        </Card>
      </Box>
      <Box h="30%" maxH={"30%"} minH={"30%"} w="100%">
        <NewsTable />
      </Box>
      <Box h="30%" maxH={"30%"} minH={"30%"} w="100%" overflowY="auto">
        <DialogMessages />
      </Box>
    </Flex>
  );
};

export default Index;
